// extracted by mini-css-extract-plugin
export default {"content":"index_content_ogsaP","source":"index_source_vFB7p","time":"index_time_68gG-"};